import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import LinearProgress from "@mui/material/LinearProgress";
import {Link} from "react-router-dom";
import "./Notification.css";


const Notification = () => {
    const notificationFakeData = [
        {
            id: 1,
            message:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.",
            date: "07-10-2023",
            isRecent: true
        },
        {
            id: 2,
            message:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.",
            date: "07-09-2023",
            isRecent: true
        },
        {
            id: 3,
            message:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.",
            date: "07-08-2023",
            isRecent: false
        },
        {
            id: 4,
            message:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.",
            date: "07-07-2023",
            isRecent: false
        },
        {
            id: 5,
            message:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.",
            date: "07-06-2023",
            isRecent: false
        }
    ];
    //#endregion

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <header className="section-heading">
                    <div>
                        <h2>Notifications</h2>
                    </div>
                    <div>
                        <Link to="" className="mark-all-read">
                            Mark all as read
                        </Link>
                    </div>
                </header>
                <div className="mb-5">
                    <Card className="notification-card active">
                        <p className="mb-2">Forms Generation Progress - (2/30)</p>
                        <LinearProgress
                            className="linear-progress"
                            variant="determinate"
                            value={35}
                        />
                    </Card>
                    {notificationFakeData.map((item) => {
                        return (
                            <Card
                                className={`notification-card ${item.isRecent ? "active" : ""}`}
                                key={item.id}
                            >
                                <p>{item?.message}</p>
                                <small className="notification-date">{item.date}</small>
                            </Card>
                        );
                    })}
                </div>
            </Box>
        </div>
    );
};


export default Notification;